import axios from "axios";

export const getAutosuggestData = async (
  companyId,
  collection,
  query = "",
  batchSize = 10000,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_VEHICLES_API}/${companyId}/autosuggest?q=${query}&collection=${collection}&num_results=${batchSize}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};

export const getAutosuggestUserData = async (
  companyId,
  collection,
  query = "",
  batchSize = 10000,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_AUTH_API}/${companyId}/autosuggest?q=${query}&collection=${collection}&num_results=${batchSize}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return {
      data: response.data.data,
    };
  } catch (e) {
    return { e };
  }
};
